export default __webpack_public_path__ + "static/media/bgImage.4e9de406.png";